import {
    connectToTopic,
    connectToTopicV2,
} from "../api";


export async function handleTopicConnection(planId, initialTopicId, newTopicId, moveResourcesCandidate) {
    let showMoveResources = false;
    let folderId = 0;

    if (initialTopicId > 0 && moveResourcesCandidate) {
        const result = await connectToTopicV2(planId, initialTopicId, newTopicId);

        if (result.canMoveResources) {
            showMoveResources = true;
        }

        folderId = result.folderId;
    } else {
        const result = await connectToTopic(planId, newTopicId);

        if (moveResourcesCandidate && initialTopicId === 0) {
            showMoveResources = true;
        }

        folderId = result.folderId;
    }

    return { showMoveResources, folderId };
}
